import { Popover } from '@mantine/core'
import { IconInfoLight } from 'components/icons/IconInfoLight'
import React from 'react'
import { colors } from 'settings/colors'

type TitleHelpIconTooltipProps = {
  children: React.ReactNode
}
// If the icon or styling here changes, also update the TitleHelpIconButton component

export const TitleHelpIconTooltip = ({ children }: TitleHelpIconTooltipProps) => {
  return (
    <Popover
      position="bottom"
      withArrow
      withinPortal
      shadow="md"
      radius={5}
      styles={{
        dropdown: {
          position: 'fixed',
          backgroundColor: colors.midnight,
          color: colors.white,
          borderColor: colors.midnight,
          fontSize: 14,
          fontWeight: 'normal',
        },
      }}
    >
      <Popover.Target>
        <div css={{ cursor: 'pointer' }}>
          <IconInfoLight />
        </div>
      </Popover.Target>
      <Popover.Dropdown>{children}</Popover.Dropdown>
    </Popover>
  )
}
